export default __webpack_public_path__ + "static/media/beauty-banner@3x.89e2e28c.png";